import React from 'react';

const Checkmark = ({ height = 32, width = 32, color = '#494949' }) => (
  <svg className="svg-icon" height={height} width={width} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <title>g check</title>
    <g fill={color}>
      <path d="M30,5c-7.25,3.125-13.997,8.56-19,14l-7-5l-3,3l10,11c4.562-8.062,10.75-16.125,20-21L30,5z" fill={color}/>
    </g>
  </svg>
);

export default Checkmark;
